import { rankingData } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          热度榜单
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          本周最受关注的擦边电影未删减版排名
        </p>
        <div className="space-y-3">
          {rankingData.map((item, idx) => (
            <a
              key={item.rank}
              href="#ranking"
              className="group flex items-center gap-4 bg-background-50 border border-background-200/70 hover:border-primary-400/30 rounded-lg px-5 py-4 transition-colors cursor-pointer"
            >
              <span
                className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full text-sm font-heading ${
                  idx === 0
                    ? 'bg-accent-500 text-background-50'
                    : idx === 1
                    ? 'bg-secondary-300 text-background-50'
                    : idx === 2
                    ? 'bg-primary-700 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-400 transition-colors truncate">
                    {item.title}
                  </h3>
                  <span className="flex-shrink-0 text-xs px-1.5 py-0.5 rounded bg-primary-500/10 text-primary-400 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 truncate">{item.desc}</p>
              </div>
              <div className="flex-shrink-0 text-right">
                <span className="text-lg font-heading text-accent-400">{item.heat}</span>
                <span className="text-xs text-foreground-400 block">热度</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}